import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import {
  Caption1,
  Caption5,
  Caption6
} from 'components/styled/typography/typography'
import withApiData from 'components/HOC/withApiData'
import UserAvatar from 'components/mini/UserAvatar'
import DraftJSRenderer from 'components/mini/DraftJSRenderer'
import FlexContainer from 'components/styled/FlexContainer'
import FlexAlignCenter from 'components/styled/FlexAlignCenter'
import ElapsedTime from 'components/utils/date/ElapsedTime'
import {
  AnnouncementListItem,
  AnnouncementListItemCard,
  NotificationDotWrapper,
  MarkableButton
} from './styles'
import ReactTooltip from 'react-tooltip'
import useLexicon from '../../../hooks/useLexicon'

const Announcement = ({
  announcement,
  toggleRead,
  showcased = false
}) => {
  const {
    course_section,
    course_section_announcement,
    master_course,
    user_master_course_notification
  } = announcement

  const el = useRef(null)
  const phase = useSelector(
    state => state.manifest.data.grade_levels[master_course.grade_level_id]
  )
  const isGuardian = useSelector(state => state.auth.user.guardian_user)

  return (
    <AnnouncementListItem
      id={`announcement-notification-${user_master_course_notification.id}`}
      isUnread={!user_master_course_notification.marked_read_at}
      showcased={showcased}
    >
      <AnnouncementListItemCard ref={el}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}
        >
          <FlexAlignCenter>
            <UserAvatar
              size={29}
              borderRadius={4}
              photoUrl={course_section_announcement.created_by.photo_url}
              isMentor
            />
            <FlexContainer
              style={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                marginLeft: '10px'
              }}
            >
              <Caption6>{course_section_announcement.created_by.name}</Caption6>
              <Caption6
                style={{ color: `#${master_course.color}`, marginTop: '2px' }}
              >
                {phase ? phase.abbreviation : '' } / {master_course.name.slice(0, 2)} /{' '}
                {course_section.name}
              </Caption6>
            </FlexContainer>
          </FlexAlignCenter>
          <FlexAlignCenter
            style={{ flexDirection: 'column', alignItems: 'flex-end' }}
          >
            <ElapsedTime
              date={course_section_announcement.created_at}
              element={Caption5}
            />
            {course_section_announcement.last_edited_at && (
              <Caption5>
                <span>
                  {' '}
                  (Edited{' '}
                  <ElapsedTime
                    date={course_section_announcement.last_edited_at}
                  />
                  )
                </span>
              </Caption5>
            )}
          </FlexAlignCenter>
        </div>
        <DraftJSRenderer
          content={course_section_announcement.text}
          styleComponent={Caption1}
          cssClass="small"
        />
      </AnnouncementListItemCard>
      {isGuardian ? (
          <NotificationDotWrapper>
            <div
              data-tip={"Only students can toggle notifications."}
              data-for={`grade-level-icon-${course_section}`}
              style={{ cursor: 'not-allowed'}}
            >
              <ReactTooltip
                multiline
                id={`grade-level-icon-${course_section}`}
                effect="solid"
              />
            <MarkableButton
              isGuardian={isGuardian}
              isRead={!!user_master_course_notification.marked_read_at}
            />
            </div>
        </NotificationDotWrapper>
      ) : (
        <NotificationDotWrapper onClick={() => toggleRead(announcement)}>
          <MarkableButton
            isRead={!!user_master_course_notification.marked_read_at}
          />
        </NotificationDotWrapper>
      )}
    </AnnouncementListItem>
  )
}

export default withApiData(Announcement)
